import styles from "./colorBox.module.scss";
import { ReactNode } from "react";

interface IProps {
    color:"light-blue" | "red" | "warning-yellow";
    children: ReactNode;
    className?: string;
}

export default function ColorBox(props: IProps) {
  const { children, color, className = "" } = props;
  return (
    <div className={`${styles.container} ${styles[color]} ${className}`}>
      {children}
    </div>
  );
}
